module.exports = __webpack_public_path__ + "static/img/pay_succ_vava.0f18464c.png";